module.exports = __webpack_public_path__ + "bg.kc4wRUUR.svg";